const floorTo = (number = 0, fractionDigits = 2) => {
  const fraction = 10 ** fractionDigits;

  return Math.floor(number * fraction) / fraction;
};

export default floorTo;
